import { providers } from '@/config/providers';
import { default as React, useEffect } from 'react';
import LoginForm from '../components/LoginForm';

function OsuLogin() {
  const provider = providers.find((provider) => provider.route === 'osu');

  useEffect(() => {
    localStorage.setItem('lastOrgReferenceCode', provider?.route ?? '');
  }, []);
  
  return (
    <div className="flex flex-col justify-center min-h-screen bg-gray-50 sm:px-6 lg:px-8">
      <LoginForm
        orgReferenceCode={provider?.route ?? ''}
        bannerLogoPath={provider?.bannerImageSrc ?? ''}
        primaryColor="#CC004E"
        bannerLogoAlt={provider?.bannerImageAlt ?? ''}
      />
    </div>
  );
}

export { OsuLogin };
